import { render, staticRenderFns } from "./tvView.vue?vue&type=template&id=1054dfc9&scoped=true&"
import script from "./tvView.vue?vue&type=script&lang=js&"
export * from "./tvView.vue?vue&type=script&lang=js&"
import style0 from "./tvView.vue?vue&type=style&index=0&id=1054dfc9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1054dfc9",
  null
  
)

export default component.exports